export enum ActionStatus {
  PENDING = "1",
  OPEN = "1",
  INPROGRESS = "2",
  APPROVED = "2",
  PAID = "3",
  REJECTED = "4",
  CLOSED = "3",
  CANCELED = "3",
  MEETINGCLOSED = "2",
  DISCUSSWITHHR = "5",
  COMPLETE = "1",
  RESCHEDULE = "2",
  DECLINED = "2",
  ACCEPTED = "1",
  NORESPONSE = "0",
  SENT = "0",
  APPRAISAL_APPROVE = "4",
  ASSIGNED = "1",
  NOT_ASSIGNED = "0",
  UPCOMING = "6",
  COMPLETED = "7"
}

export enum ModifiedActionStatus {
  VIEW = "VIEW",
  PENDING = "PENDING",
  INPROGRESS = "IN PROGRESS",
  APPROVED = "APPROVED",
  PAID = "PAID",
  REJECTED = "REJECTED",
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  CANCELED = "CANCELLED",
  DISCUSSWITHHR = "UNDER REVIEW",
  COMPLETE = "COMPLETE",
  RESCHEDULE = "RESCHEDULE",
  ACCEPT = "ACCEPTED",
  DECLINE = "DECLINE",
  INHOLD = "ON HOLD",
  INCOMPLETE = "INCOMPLETE",
  MOREOPTION = "MORE",
  APPRAISAL_APPROVE = "APPRAISAL_APPROVED",
  SENT = "SENT",
  ASSIGNED = "ASSIGNED",
  NOT_ASSIGNED = "NOT_ASSIGNED",
  REPORT = "REPORT",
  UPCOMING = "UPCOMING",
  COMPLETED = "COMPLETED"
}
